<template>
  <div class="alpha-bank-header">
    <div class="alpha-bank-header__title">
      Оплата заказа
    </div>
    
    <p v-if="orderId" class="alpha-bank-header__order-id">
      Заказ №{{ orderId }}
    </p>
    
    <p v-if="amountFormatted" class="alpha-bank-header__amount">
      К оплате: {{ amountFormatted }} ₽
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  orderId?: string | number
  amountFormatted?: string
}

withDefaults(defineProps<Props>(), {
  orderId: undefined,
  amountFormatted: ''
})
</script>

<style scoped lang="scss">
.alpha-bank-header {
  @apply grid gap-3 items-center justify-center text-center;

  &__title {
    @apply font-semibold text-3xl;
  }

  &__order-id {
    @apply text-xl text-gray-500;
  }

  &__amount {
    @apply text-base font-bold text-orange-600;
  }
}
</style>
